import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook to preload translation namespaces before they are needed.
 * This prevents UI refresh when translations are loaded on-demand.
 */
export const usePreloadTranslations = (namespaces: string[]) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const preloadNamespaces = async () => {
      for (const ns of namespaces) {
        if (!i18n.hasLoadedNamespace(ns)) {
          await i18n.loadNamespaces(ns);
        }
      }
    };

    preloadNamespaces();
  }, [i18n, namespaces]);
};
